// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bat[data-v-1e05a65b] .sponsoring__container.webrivage-optin-client {\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
